import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ArabicCourseTeacher() {
  return (
    <section className="my-48">
      <div className="my-10 flex flex-col md:flex-row items-center md:items-start">
        <div className="justify-center">
          <p className="bg-green-100 p-5 rounded">
            <FontAwesomeIcon
              className="text-4xl text-green-600"
              icon={faUser}
            />
          </p>
        </div>
        <div className="px-2">
          <p className="font-bold ">কোর্স শিক্ষকঃ</p>
          <p className="text-xl text-green-600">ফাইসাল</p>
          <p>ম্যানেজার, আল হারামাইন ইসলামিক একাডেমি অনলাইন।</p>
          <p>
            তিনি সৌদি আরবের কিং খালিদ বিশ্ববিদ্যালয় থেকে অনার্স এবং আরবি ভাষা
            ইন্সটিটিউট থেকে ডিপ্লোমা করেছেন।
          </p>
          <p>এরআগে, তিনি বাংলাদেশে কওমী ও আলিয়া মাদরাসায় পড়াশোনা করেছেন।</p>
          <p>প্রায় ৩ বছর ধরে অনলাইনে আরবি ভাষা শেখাচ্ছেন।</p>
          <p className="mt-5">
            আল্লাহ সুবহানাহু ওয়া তায়ালা তাকে হায়াতে ত্বয়্যেবা দান করুন এবং তার
            ইলম ও আমলে বারাকাহ দান করুন। তার ত্যাগ, শ্রম ও কাজগুলো কবুল করুন।
            আমীন।
          </p>
        </div>
      </div>
    </section>
  );
}
